import auth0 from 'auth0-js'
import Vue from 'vue'
import firebase from '@/firebase'
import axios from 'axios'

let webAuth = new auth0.WebAuth({
    domain: 'clout.eu.auth0.com',
    clientID: 'RFSNJbwwjCwQ8QysPeqm4AKztSckuYVA',
    redirectUri: process.env.VUE_APP_AUTH_URL,
    audience: 'https://clout.eu.auth0.com/userinfo',
    responseType: 'token id_token',
    scope: 'openid'
})

let auth = new Vue({
  computed: {
    token: {
      get: function() {
        return localStorage.getItem('id_token')
      },
      set: function(id_token) {
        localStorage.setItem('id_token', id_token)
      }
    },
    accessToken: {
      get: function() {
        return localStorage.getItem('access_token')
      },
      set: function(accessToken) {
        localStorage.setItem('access_token', accessToken)
      }
    },
    expiresAt: {
      get: function() {
        return localStorage.getItem('expires_at')
      },
      set: function(expiresIn) {
        let expiresAt = JSON.stringify(expiresIn * 36000 + new Date().getTime())
        localStorage.setItem('expires_at', expiresAt)
      }
    },
    user: {
      get: function() {
        return JSON.parse(localStorage.getItem('user'))
      },
      set: function(user) {
        localStorage.setItem('user', JSON.stringify(user))
      }
    },
    client() {
      return axios.create({ baseURL: 'https://time-reg.firebaseapp.com' });
    }
  },
  methods: {
    isAdmin() {
      const role = JSON.parse(localStorage.getItem('profile')).role;
      if(role == 'admin') {
          return true
      } else {
          return false
      }
    },
    tenantid() {
      if (firebase.auth().currentUser !== null) {
        const uid = firebase.auth().currentUser.uid;

        firebase.database().ref('/users/' + uid + '/adminCanEdit/').once('value').then(function(snapshot) {
          const tenantid = snapshot.val().tenant_id || null;
          return tenantid;
        });
        // return tenantid;
      } else {
        return null
      }
    },
    login() {
      webAuth.authorize()
    },
    logout() {
      return new Promise((resolve, reject) => { 
        localStorage.removeItem('access_token')
        localStorage.removeItem('id_token')
        localStorage.removeItem('expires_at')
        localStorage.removeItem('user')

        // logout of Firebase
        firebase.auth().signOut().then(function() {
          // Sign-out successful.
        }).catch(function(error) {
          // An error happened.
          console.log("logout error: " + error.message)
        });

        webAuth.authorize()
      })
    },
    isAuthenticated() {
      return new Date().getTime() < this.expiresAt
    },
    getToken(uid) {
      const client = axios.create({ baseURL: 'https://europe-west1-time-reg.cloudfunctions.net' });

      client.post('/createToken', {
          uid: uid
        }).then((response) => {
          firebase.auth().signInWithCustomToken(response.data)
          .then(function() {
              if (firebase.auth().currentUser !== null) {
                const uid = firebase.auth().currentUser.uid;
        
                firebase.database().ref('/users/' + uid).once('value').then(function(snapshot) {
                  const userSnap = snapshot.val();
                  if(userSnap) {
                    // mimick azure login profile and set in localStorage
                    const profile = {
                      "tenantid": userSnap.adminCanEdit.tenant_id || false,
                      "user_id": uid || false,
                      "role":  userSnap.adminCanEdit.role || false
                    }
                    localStorage.setItem('profile', JSON.stringify(profile));
                    }
                });
                // return tenantid;
              }
          })
          .catch(function(error) {
              console.log("signInWithCustomToken error: " + error.message)
              // reject(error)
          });
        })
    },
    handleAuthentication() {
        return new Promise((resolve, reject) => {  
            webAuth.parseHash((err, authResult) => {
              if (authResult && authResult.accessToken && authResult.idToken) {
                  this.expiresAt = authResult.expiresIn
                  this.accessToken = authResult.accessToken
                  this.token = authResult.idToken
                  this.user = authResult.idTokenPayload
                  try {
                    this.getToken(this.user.sub)
                  } catch(error) {
                    console.log(error)
                  }
                  resolve()
              } else {
                  this.logout()
                  reject()
              }
          })
        })
    }
  }
})

export default {
  install: function(Vue) {
    Vue.prototype.$auth = auth
  }
}
